import { parseCsvSelection } from './csvSelection';
import { criteriaLabelsFromSelection } from './judgingCriteriaPresets';

export function generateJudgingFromAnswers(answers: Record<string, string>): {
    score_criteria: string[];
} {
    const contestType = answers.contest_type || 'acting';
    const selected = parseCsvSelection(answers.selected_criteria);

    return {
        score_criteria: criteriaLabelsFromSelection(contestType, selected),
    };
}
